import { render, staticRenderFns } from "./setFormDrag.vue?vue&type=template&id=e7a1c780&scoped=true"
import script from "./setFormDrag.vue?vue&type=script&lang=js"
export * from "./setFormDrag.vue?vue&type=script&lang=js"
import style0 from "./setFormDrag.vue?vue&type=style&index=0&id=e7a1c780&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a1c780",
  null
  
)

export default component.exports